import PdfViewer from "../../../../../components/PdfViewer";
import { isPdfAttachment } from "../../../../../components/PdfViewer/loadPdf";
import { PrintButton } from "../../../../../components/PrintButton";
import { getGuideLearningKind } from "../../../../../shared/guideNames.js";
import { LearningVideo } from "../../../../../components/LearningVideo/index.jsx";
import React, { useState } from "react";
import { HtmlContentFrame } from "../../../../../components/HtmlContentFrame";
import api from "../../../../../services/api";
import { sourceImage } from "../../../../../utils/source-image";
const DOWNLOAD_ICON = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M12 3V14M12 14L16.5 9.5M12 14L7.5 9.5M5 17.5H19"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
async function baixarArquivo(fileUrl, fileName) {
  if (!fileUrl || fileUrl === "#") {
    return;
  }
  const sourcePath = (() => {
    try {
      const parsedUrl = new URL(fileUrl, window.location.origin);
      return `${parsedUrl.pathname}${parsedUrl.search}`;
    } catch {
      return fileUrl;
    }
  })();
  const response = await api.get("/conteudos/anexo", {
    params: {
      path: sourcePath,
      name: fileName || "anexo",
    },
    responseType: "blob",
  });
  const blob = response.data;
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = fileName || "anexo";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(objectUrl);
}
function DownloadAttachmentButton({
  isPdf,
  fileUrl,
  fileName,
  label = "Baixar",
}) {
  const [isDownloading, setIsDownloading] = useState(false);
  const handleDownload = async () => {
    if (isDownloading) {
      return;
    }
    setIsDownloading(true);
    try {
      await baixarArquivo(fileUrl, fileName);
    } finally {
      setIsDownloading(false);
    }
  };
  return (
    <button
      type="button"
      onClick={handleDownload}
      disabled={isDownloading}
      style={{
        ...(!isPdf
          ? {
              width: "100%",
            }
          : {}),
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        color: "#616161",
        background: isDownloading ? "#f0f1f1" : "#e3e4e4",
        border: "1px solid #dadada",
        borderRadius: 10,
        padding: "10px 18px",
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: "0.01em",
        boxShadow: "0 8px 18px rgba(15, 118, 110, 0.08)",
        cursor: isDownloading ? "wait" : "pointer",
        opacity: isDownloading ? 0.85 : 1,
      }}
    >
      {DOWNLOAD_ICON}
      {isDownloading ? "Baixando..." : label}
    </button>
  );
}
function getEmbedUrl(url) {
  if (!url) return "";
  try {
    const ytMatch = url.match(
      /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})/,
    );
    if (ytMatch && ytMatch[1]) {
      return `https://www.youtube.com/embed/${ytMatch[1]}`;
    }
    const vimeoMatch = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vimeoMatch && vimeoMatch[1]) {
      return `https://player.vimeo.com/video/${vimeoMatch[1]}`;
    }
  } catch (error) {
    // Ignora erros de parsing e retorna a url original
  }
  return url;
}
export function renderBloco(bloco, options = {}) {
  const onImageClick =
    "function" === typeof options.onImageClick ? options.onImageClick : null;
  const instanceKey = [
    "olimpiada",
    options.studentId ?? "anon",
    options.aulaId ?? "-",
    options.guiaId ?? "-",
    bloco.id,
  ].join(":");
  if ("texto" === bloco.tipo)
    return (
      <div>
        <PrintButton htmlContent={bloco.html} title={"Imprimir texto"} />
        <HtmlContentFrame
          html={bloco.html || ""}
          title={"Texto da aula"}
          instanceKey={instanceKey}
          contentKind={getGuideLearningKind(options.guiaNome) || "resumo"}
        />
      </div>
    );
  if ("video" === bloco.tipo) {
    const videoUrl = getEmbedUrl(bloco.html);
    return (
      <div>
        <LearningVideo
          src={videoUrl}
          contextKey={instanceKey}
          allow={
            "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share;"
          }
          title={"Vídeo"}
          style={{
            width: "100%",
            height: 300,
            border: "1px solid #E4EDF2",
            borderRadius: 12,
          }}
        />
      </div>
    );
  }
  if ("html" === bloco.tipo)
    return (
      <div>
        <PrintButton
          htmlContent={bloco.html}
          title={"Imprimir conteúdo interativo"}
        />
        <HtmlContentFrame
          html={bloco.html || ""}
          title={"Conteudo interativo"}
          instanceKey={instanceKey}
          contentKind={getGuideLearningKind(options.guiaNome)}
        />
      </div>
    );
  if ("anexo" === bloco.tipo) {
    const arquivos = Array.isArray(bloco.arquivos) ? bloco.arquivos : [];
    return (
      <div
        style={{
          display: "grid",
          gap: 10,
        }}
      >
        {arquivos.map((arquivo, index) => {
          const arquivoUrl =
            arquivo.url && "#" !== arquivo.url ? sourceImage(arquivo.url) : "#";
          const ext = (arquivo.ext || "").toLowerCase();
          const isImage = ["jpg", "jpeg", "png", "gif", "webp"].includes(ext);
          const isPdf = isPdfAttachment(arquivo) && arquivoUrl && "#" !== arquivoUrl;
          return (
            <div key={arquivo.id || index}>
              {isImage && (
                <div
                  style={{
                    borderRadius: 12,
                    overflow: "hidden",
                    border: "1px solid #E4EDF2",
                    marginBottom: 8,
                  }}
                >
                  <img
                    src={arquivoUrl}
                    alt={arquivo.nome}
                    onClick={() => onImageClick?.(arquivoUrl)}
                    style={{
                      width: "100%",
                      maxHeight: 280,
                      objectFit: "contain",
                      cursor: onImageClick ? "zoom-in" : "default",
                      display: "block",
                    }}
                  />
                </div>
              )}
              {isPdf ? (
                <PdfViewer
                  fileUrl={arquivoUrl}
                  fileName={arquivo.nome}
                  downloadControl={<DownloadAttachmentButton
                    isPdf={true}
                    fileUrl={arquivoUrl}
                    fileName={arquivo.nome}
                    label="Baixar PDF"
                  />}
                />
              ) : (
                <DownloadAttachmentButton
                  isPdf={false}
                  fileUrl={arquivoUrl}
                  fileName={arquivo.nome}
                  label={"Baixar"}
                />
              )}
            </div>
          );
        })}
        {!arquivos.length && (
          <div
            style={{
              color: "#94A3B8",
              fontSize: 13,
            }}
          >
            {"Nenhum anexo."}
          </div>
        )}
      </div>
    );
  }
  return null;
}
export { getEmbedUrl };
